<script>
import { Radar } from 'vue-chartjs';

export default {
    extends: Radar,
    props: {
        title: {
            type: String,
            default: null,
        },
        labels: {
            type: Array,
            default: () => [],
        },
        datasets: {
            type: Array,
            default: () => [],
        }
    },
    computed: {
        data(vm = this) {
            return {
                labels: vm.labels,
                datasets: vm.datasets,
            }
        },
        options(vm = this) {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scale: {
                    ticks: {
                        beginAtZero: true,
                        max: 3,
                        display: false,
                    },
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    callbacks: {
                        title: function (tooltipItem, data) {
                            return data.datasets[tooltipItem[0].datasetIndex].label
                        },
                        label: function (tooltipItem, data) {
                            return data.datasets[tooltipItem.datasetIndex].dataReal[tooltipItem.index]
                        },
                    }
                },
            }
        }
    },
    mounted() {
        const vm = this
        vm.initChart()
    },
    methods: {
        initChart() {
            const vm = this
            vm.renderChart(vm.data , vm.options)
        }
    },
    watch: {
        data() {
            const vm = this
            vm.initChart()
        },
        options() {
            const vm = this
            vm.initChart()
        }
    }
};
</script>